module.exports = __webpack_public_path__ + "727a6d34ba57a92f2959f744335b9ef5.png";